import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  hint?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, hint, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex items-baseline justify-between gap-4 flex-wrap">
      <div>
        <h1 className="text-xl font-semibold tracking-[-0.24px]">{title}</h1>
        {hint && (
          <p className="text-xs text-[var(--color-fg-subtle)] mt-0.5">{hint}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
